import { HttpService } from '@/shared/lib'

export class DeleteReservaProdutoService extends HttpService {
  async execute(idExternoProduto: number) {
    return this.http.delete(`/api/v2/ReservaDoProduto/${idExternoProduto}`)
  }
}
